export const translationsEn = {
  welcome: "Welcome to Admin Page!",
  Navbar: {
    Register: "Register",
    Login: "Login",
  },
  SiteMode: {
    Dark: "Dark",
    Light: "Light",
  },
  SideBarBtns: {
    Collections: "Collections",
    Mycollection: "My Collections",
    CreateCollection: "Create Collection",
    Users: "Users",
  },
  Search: {
    placeholder: "Search...",
    search: "Search",
  },
  NoItem: "Collection does not have item yet!",
  NoCollection: "You do not have collections yet. Create",
  ItemSectionTitle: "Items",
  UserPermission: "You are not allowed. Please register",
  ClickToRegister: "here",
  SuccessMsg: "Successfully updated",
  CollectionModal: {
    Title: "Create Collection",
    Name: "Name",
    Markdown: "Support Markdown",
    Description: "Description",
    Topic: "Topic",
    UploadImg: "Upload an image",
    AddCustomField: "Add Custom Field",
    Create: "Create",
    SuccessMsg: "Added successfully",
    SuccessMsgCreate: "Collection successfully created",
    SuccessMsgCustomField: "Added successfully",
  },
  CollectionBtn: {
    View: "View",
    Delete: "Delete",
  },
  ItemModal: {
    Title: "Create Item",
    Name: "Name",
    EnterTag: "Enter tag",
    UploadImg: "Upload an image",
    Create: "Create",
    SuccessMsg: "Item successfully created",
  },
  ItemBtn: {
    View: "View",
    Delete: "Delete",
  },
  UserRegistration: {
    Title: "Create an account",
    Username: "Username",
    Email: "Email",
    Password: "Password",
    Signup: "Sign Up",
    Login: "Sign in",
    OrContinueWith: "Or continue with",
    SuccessMsg: "Successfully registered! Wait a sec!",
    SuccessMsgForlogin: "Successfully logged in",
    HaveAccount: "Already have an account?",
    ExistErrorMsg: "User with this email already exist!",
    NotFoundMsg: "User with this email not found",
    BlockedMsg: "User account blocked. You cannot log in!",
    ServerMsg: "Something really bad happened in server side",
    AllFieldsMsg: "All fields are required to fill"
  }
};
